/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable no-debugger */
import axios from 'axios';
import { baseURL } from '../constants';

async function login(email, type) {
    let payload = {
        username: email,
    };
    payload = JSON.stringify(payload);

    try {
        const data = await axios.post(`${baseURL}/distributors/sign-in`, payload);
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error, code: error.response?.data?.error_code };
    }
}
async function VerifyOtp(email, otp, session,type) {
    let payload = {
        username: email,
        otp,
        session,
    };
    payload = JSON.stringify(payload);
    try {
        const data = await axios.post(`${baseURL}/distributors/verify-otp`, payload);
        localStorage.setItem('user', JSON.stringify(data.data.data));

        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message, code: error.response.data.error_code };
    }
}

async function resendOtp(email, session, type) {
    let payload = {
        username: email,
        session,
    };
    payload = JSON.stringify(payload);
    try {
        const data = await axios.post(`${baseURL}/distributors/resend-otp`, payload);
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message, code: error.response.data.error_code };
    }
}

async function appStatus() {
    try {
        const data = await axios.get(`${baseURL}/distributors/app-status`);
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response?.data?.message };
    }
}
function logout() {
    localStorage.removeItem('user');
    history.push('/');
    window.location.reload();
}

async function appVersion(body) {
    let payload = body;
    payload = JSON.stringify(payload);
    try {
        const data = await axios.post('https://hmfmozn8fj.execute-api.ap-south-1.amazonaws.com/dev/list', payload);
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

export const userService = {
    appStatus,
    appVersion,
    login,
    logout,
    VerifyOtp,
    resendOtp,
};
